import React from 'react'
import {Link} from 'react-router-dom'

class Code extends React.Component {

    componentDidMount() {
        document.title = "sweaverD.com - Coding and Expertise"
    }

    render = () => {

        return (
            <div className="grid" id="codePage">
                <article id="expertise">
                    <div><h1 className="nostyle"><i className="fa fa-code"><span>Expertise</span></i></h1></div>
                    <div>
                        <ul id="skills">
                            <li>JavaScript and the World Wide Web</li>
                            <li>Full stack coding ability</li>
                            <li>UI/UX Design</li>
                        </ul>
                    </div>

                    <br style={{ clear: "both" }} />
                    <p>I'm offering "full-stack front end" expertise building web applications.   I enjoy patterns, visualizations, Web APIs, beaches, and of course, regular expressions. Although I am seeking to leverage my existing skills within the JavaScript/Web/React/HTML/CSS tech stack, I place a high value on being given the opportunity to learn things I don't already know (which is a lot).</p>

                    <p>At the end of the day, of course, it's not really about the programming language you used, it's about the algorithm, and the presentation thereof. I like to build cohesive wholes and solve problems creatively.</p>

                    <p>Check out some of my open-source <Link to="/projects">projects</Link>.</p>
                </article>

                <article>
                    <h1><i className="fab fa-stack-overflow" style={{ float: "left", padding: "15px" }}><span>Community</span></i></h1>
                    <a target="_blank" rel="noopener noreferrer" style={{ float: "left", padding: "15px" }} className="stackoverflow" href="https://stackoverflow.com/users/story/244811?view=Timeline">
                        <img src="http://stackoverflow.com/users/flair/244811.png?theme=dark" alt="Scott's Stackoverflow profile"
                            title="Scott's Stackoverflow profile" />
                    </a>
                    <p>Stackoverflow.com is a coders' Q & A site, a community of 6.6 million programmers, and a vast archive of
                      information about programming. It's a place where you can show your skills and gain <a target="_blank" rel="noopener noreferrer" href="https://stackoverflow.com/users/244811/scott-weaver?tab=profile">reputation points</a> by answering questions.</p>
                    <p>Fun Fact: the Stack Exchange framework was built with .NET MVC.</p>
                </article>

            </div>

        )
    }
}
export default Code